export default function ImpactReporth3(props) {
    const hyphenateAndLowercase = (str) => {
        // return str.replace(/\s+/g, '-').toLowerCase();
        return str
            .replace(/[^\w\s-]/g, '')   // Remove special characters except spaces and hyphens
            .replace(/\s+/g, '-')       // Replace spaces with hyphens
            .toLowerCase();
      }

    const id = hyphenateAndLowercase(props.children);

    return (
        <h3 
            id={id} 
            className={`impact-h3${props.className ? ' ' + props.className : ''}`}
            style={props.style}
        >
            {props.children}
        </h3>
    );

}